import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import HomeDecorCrousel from "./HomeDecorCrousel";
import CardsCrousell from "./CardsCrousell";
import Pots from "./Pots";

const HomeDecor = () => {
  return (
    <Box>
      <Text
        className="oswald-font"
        color={"#3C375F"}
        fontSize={{ md: "25px", base: "20px" }}
        fontWeight={"bold"}
        letterSpacing={"0px"}
      >
        Home Decor
      </Text>
      <Text
        color={"#7D7D7D"}
        fontSize={{ md: 16, base: 13 }}
        className="lato-font"
        fontWeight={"regular"}
      >
        Shop Our Bestsellers - The Plants That Everyone Is Buying
      </Text>
      <Flex mt={5} alignItems={"center"}>
        <Box w={{ md: "100%", base: "100%" }}>
          <HomeDecorCrousel />
        </Box>
      </Flex>
      <Box mt={5}>
        <Text
          className="oswald-font"
          color={"#3C375F"}
          fontSize={{ md: "25px", base: "20px" }}
          fontWeight={"bold"}
          letterSpacing={"0px"}
        >
          All Cards
        </Text>
        <Text
          color={"#7D7D7D"}
          fontSize={{ md: 16, base: 13 }}
          className="lato-font"
          fontWeight={"regular"}
        >
          View Our Best Greeting Card.
        </Text>
        <Flex mt={5} alignItems={"center"}>
          <Box w={{ md: "100%", base: "100%" }}>
            <CardsCrousell />
          </Box>
        </Flex>
      </Box>
      <Box mt={4}>
        <Pots />
      </Box>
    </Box>
  );
};

export default HomeDecor;
